import { IRequestBuilder } from "./RequestBuilder";

class RequestRegister {

    protected _requestBuilders: Map<string, IRequestBuilder>;

    constructor() {
        this._requestBuilders = new Map<string, IRequestBuilder>();
    }

    add(id: string, requestBuilder: IRequestBuilder) {
        this._requestBuilders.set(id, requestBuilder);
    }

    has(id: string) {
        return this._requestBuilders.has(id);
    }

    get(id: string): IRequestBuilder {
        if (!this._requestBuilders.has(id)) {
            throw  new Error("Request Builder with ID " + id + " is not available!");
        }
        return this._requestBuilders.get(id);
    }

}

export default new RequestRegister();